import { render, staticRenderFns } from "./Nixia.vue?vue&type=template&id=ffe9e346&scoped=true&"
import script from "./Nixia.vue?vue&type=script&lang=js&"
export * from "./Nixia.vue?vue&type=script&lang=js&"
import style0 from "./Nixia.vue?vue&type=style&index=0&id=ffe9e346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe9e346",
  null
  
)

export default component.exports